<app-icon
	*ngIf="!financialInstitution?.logoUrl"
	[icon]="ICON.MORTGAGE"
	class="text-2xl text-grey"
></app-icon>
<img
	*ngIf="financialInstitution?.logoUrl"
	class="max-h-10 institution-logo p-2 pr-0"
	[src]="'/assets/images/banks/' + financialInstitution?.logoUrl"
/>
